module.exports = __webpack_public_path__ + "img/72_8.8997d05c.png";